import { render, staticRenderFns } from "./Wrap.vue?vue&type=template&id=47cf2804&scoped=true"
import script from "./Wrap.vue?vue&type=script&lang=js"
export * from "./Wrap.vue?vue&type=script&lang=js"
import style0 from "./Wrap.vue?vue&type=style&index=0&id=47cf2804&prod&lang=scss&scoped=true"
import style1 from "./Wrap.vue?vue&type=style&index=1&id=47cf2804&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cf2804",
  null
  
)

export default component.exports